import { useEffect, useState } from "react";
import Toaster from "../../Components/Toaster";
import TokenService from "../../Services/Token.service";
import { UserService } from "../../Services/User.service";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Helmet } from "react-helmet";
import Loader from "../../Components/Loader";

function EmailSmsAlerts() {

    
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [initialValues, setInitialValues] = useState({});
    const [alerts, setAlerts] = useState({});
    const [validationSchema, setValidationSchema] = useState();
    const [loading, setLoading] = useState(false);
    const [userRoles, setUserRoles] = useState(TokenService.getUserRoles());

    useEffect(() => { 
        fetchAlerts();
    }, []); 

    const fetchAlerts = async () => {

        setLoading(true);

        try {
            const alertData = await UserService.userAlerts(TokenService.getUserId());
            if(alertData.success) {
                 
                const initialValues = alertData.alerts.reduce((acc, alert) => {
                    
                    if (alert.user_alerts && alert.user_alerts.length > 0) {                        
                        acc[`alert_${alert.id}`] = alert.user_alerts.reduce((result, userAlert) => {
                            
                            if (userAlert.alert_type === 'both' || userAlert.alert_type === 'email') {
                                return 'yes';
                            }
                            else if (userAlert.alert_type === 'sms' || userAlert.alert_type === ''  ){
                                return 'no';
                            }
                        }, 'no');

                    } else {
                        acc[`alert_${alert.id}`] = 'no';
                    }
                
                    return acc;
                }, {});
                
                setInitialValues(initialValues);
                

                const validationSchema = Yup.object().shape(
                    alertData.alerts.reduce((schemaAcc, alert) => {
                      schemaAcc[`alert_${alert.id}`] = Yup.string().required(`This is required.`);
                      return schemaAcc;
                    }, {})
                );
                setValidationSchema(validationSchema);
                setAlerts(alertData.alerts);   
                setLoading(false);                    

            } else {    
                setInitialValues({}); 
                setValidationSchema({});
                setAlerts({});           
                setToastMessage(alertData.message);
                setToastVariant('error');
                setLoading(false);        
            }
        } catch (error) {
            setInitialValues({}); 
            setValidationSchema({});
            setAlerts({});   
            setLoading(false);        
            console.error("Error fetching sample types", error);
        }
    }
   
    const handleSubmit = async (values) => {
        
        setLoading(true); 
        let params = {
            user_id: TokenService.getUserId(),
        };

        const alertData = {
            alerts: Object.keys(values).reduce((acc, key) => {
              const alertId = key.split('_')[1]; 
              acc[alertId] = values[key] == 'yes' ? ['email'] : []; 
              return acc;
            }, {})
        };

        params = {
            ...params,
            ...alertData
        };

        try {           
            const data = await UserService.updateAlerts(params);           
            if (!data.success) {
                let message = '';
                if (typeof data.message === 'object' && data.message !== null) {
                    message = Object.values(data.message).flat().join(', '); 
                } else if (Array.isArray(data.message)) {
                    message = data.message.join(', ');
                } else {
                    message = data.message || 'An unknown error occurred.';
                }
                setToastMessage(message);
                setToastVariant('error');
            } else {
                setToastMessage(data.message);
                setToastVariant('success');
            }
        } catch (error) {
            console.log("error", error);
            setToastMessage('Failed to update.');
            setToastVariant('error');
        } finally {
            setLoading(false);
            setShowToast(true);
        }
       
    };

    return (
        <>
            <Loader loading={loading} />

            <Helmet>
                <title>DonorX | Email Alerts</title>
            </Helmet>

            <div className="el-middle-wrapper">
                <h2 className="el-title">Email Alerts</h2>            
                
                <div className="">    
                    <>
                        <div className="el-bg-table el-super-admin mt-5">
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                validateOnBlur={true}
                                validateOnChange={true}
                                onSubmit={handleSubmit}
                                enableReinitialize={true} // Enable reinitialization when initialValues change
                            >
                                {({ values, setFieldValue, setFieldTouched, errors, touched }) => (
                                    <Form>

                                        {(typeof userRoles != 'undefined' && userRoles.includes("Donor") && 
                                            <div className="row mt-3">
                                                <label>For Donors. Notify me when:</label>
                                            </div>
                                        )}

                                        {(alerts && Array.isArray(alerts) ? alerts : []).map((alert) => (
                                            <div className="row mt-3 col-xl-3 radio-wrapper" key={alert.id}>
                                                <label className="form-label-check">
                                                    {alert.title}
                                                </label>
                                                <div className="d-flex mt-3">                                                            
                                                    {['yes', 'no'].map((alertType) => {               
                                                                                             
                                                        const isSelected = values[`alert_${alert.id}`]?.includes(alertType);
                                                        return (
                                                            <div className="form-check" key={alertType}>
                                                                <Field
                                                                    type="radio"
                                                                    id={`email-alert-${alertType}`}
                                                                    name={`alert_${alert.id}`}
                                                                    value={alertType}
                                                                    className="form-check-input radio-pointer"
                                                                    checked={!!isSelected}
                                                                />
                                                                <label htmlFor={`email-alert-${alertType}`} className="form-check-label ms-2 radio-pointer">
                                                                    {alertType.charAt(0).toUpperCase() + alertType.slice(1)}
                                                                </label>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                <ErrorMessage
                                                    name={`alert_${alert.id}`}
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </div>
                                        ))}
                                                
                                        
                                        <div className="d-flex align-items-center mt-4">
                                            <button type="submit" className="el-main-button me-3"> <span>Update</span> </button>
                                        </div>                                        

                                        
                                    </Form>
                                    
                                    
                                   
                                )}
                            </Formik>
                        </div>
                    </>
                </div>
            </div>            
            
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </>
    );
}

export default EmailSmsAlerts;